

export const isSSR = () => typeof window === "undefined";

const service = {
    isSSR
};

export default service;